import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';

// Prettify a raw category key (e.g. 'sim_rig_brackets' -> 'Sim Rig Brackets').
const prettifyKey = (key) =>
  (key || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();

// Returns a function resolving a category key to its live Category label,
// falling back to a prettified key when no Category record matches.
export function useCategoryLabels() {
  const { data: categories = [] } = useQuery({
    queryKey: ['categories'],
    queryFn: () => base44.entities.Category.list(),
    staleTime: 5 * 60 * 1000,
  });

  const map = {};
  for (const c of categories) {
    if (c.key) map[c.key] = c.label || prettifyKey(c.key);
  }

  return (key) => map[key] || prettifyKey(key);
}